import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";

const Global = ({ children }) => {
  const theme = useThemeHook();

  // Page transition ads removed - ads now only shown on HomePage at 3-minute intervals

  return (
    <>
      {children}
    </>
  );
};

export default Global;

